import React from "react";
import SummaryLineItem from "../events/event/cart/summary-line-item";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPublicTournament,
} from "../../reducers/tournamentSlice";
import {
  selectCompletedOrder,
  selectRegistrationCustomer,
  selectRegistrationOrder,
  updateOrderThunk,
} from "../../reducers/registrationOrderSlice";
import { moneyWithCommas } from "../../helpers/RegexHelper";
import { GSToggle } from "golfstatus_react_components";
import { usePermissions } from "../../hooks/permissionHooks";

const CheckoutFeesWidget = (props) => {
  const { complete } = props;
  const completedOrder = useSelector(selectCompletedOrder);
  const inProgressOrder = useSelector(selectRegistrationOrder);
  const registrationOrder = complete ? completedOrder : inProgressOrder;
  const registrationCustomer = useSelector(selectRegistrationCustomer)

  const permissions = usePermissions();

  const tournament = useSelector(selectPublicTournament);

  const dispatch = useDispatch();

  const toggleFees = () => {
    const registrantCoversFees = !registrationOrder?.registrantCoversFees
    const update  = {...registrationOrder, registrantCoversFees, registrationCustomer}
    dispatch(updateOrderThunk(update))
  };

  const getContent = () => {
    if (complete) {
      return null;
    }
    if (permissions.hideFees()) {
      return null;
    }
    return (
      <GSToggle
        trueDescription={`Pay Fees`}
        falseDescription={"Don't Pay Fees"}
        value={registrationOrder?.registrantCoversFees}
        onClick={() => {
          toggleFees();
        }}
      />
    );
  };

  return (
    <SummaryLineItem
      label="Fee"
      description={
        !complete && !permissions.hideFees()
          ? `${tournament?.organization?.name} will pay a fee for this transaction, but you can cover it for them!`
          : null
      }
      value={
        registrationOrder?.registrantCoversFees
          ? moneyWithCommas(registrationOrder?.totalPlatformFee)
          : null
      }
      content={getContent()}
    />
  );
};

export default CheckoutFeesWidget;
